import { render, staticRenderFns } from "./baseEdit.vue?vue&type=template&id=83d4e052&scoped=true"
import script from "./baseEdit.vue?vue&type=script&lang=js"
export * from "./baseEdit.vue?vue&type=script&lang=js"
import style0 from "./baseEdit.vue?vue&type=style&index=0&id=83d4e052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d4e052",
  null
  
)

export default component.exports